import { EventAnalyticsSummaryDto } from 'legacy/events/types';

import { useQuery } from 'react-query';
import { ErrorResponse } from 'legacy/common/utils/error';
import { getEventAnalyticsSummary } from '../service';

export function useEventDashboardTotals({ eventId }: { eventId: string }) {
  return useQuery<EventAnalyticsSummaryDto, ErrorResponse>(
    ['totals', { eventId }],
    () => getEventAnalyticsSummary({ eventId })
  );
}
